export function checkRole(user, role) {
  if (!user || !user.roles) return false;

  const acceptableRoles = ["super"];

  if (role !== "super") {
    acceptableRoles.push("admin");
    if (role !== "admin") {
      acceptableRoles.push("users");
      if (role !== "users") {
        acceptableRoles.push(role);
      }
    }
  }

  return user.roles.some(r => acceptableRoles.includes(r.role));
}
